import * as fromRoot from './app.state';
import { UserModel } from '../model/IUser';
import { UserAction, UserActionTypes } from './user.action';
import { createFeatureSelector, createSelector } from '@ngrx/store';


var usermodel = new UserModel();

export interface State extends fromRoot.State {
    userState: UserState;
}

export interface UserState {
    user: UserModel;
}

const initialState: UserState = {
    user: usermodel
};

const getUserFeatureState = createFeatureSelector<UserState>('userState');


export const getLoggedInuser = createSelector(
    getUserFeatureState,
    state => state.user
);

export function reducer(state = initialState, action: UserAction): UserState {

    switch (action.type) {
        case UserActionTypes.SetCurrentUser:
            return {
                ...state,
                user: action.payload
            };
        case UserActionTypes.LogOutUser:
            return {
                ...state,
                user: usermodel
            };
        default:
            return state;
    }
}
